import React from "react";
import { SvgIconProps } from "@mui/material";
import LocalFireDepartmentIcon from "@mui/icons-material/LocalFireDepartment";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import SpaIcon from "@mui/icons-material/Spa";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
// MUI has no "Eco" icon; the leaf below is the closest match to MaterialIcons "eco".
import EcoIcon from "@mui/icons-material/EnergySavingsLeaf";
import BoltIcon from "@mui/icons-material/Bolt";
import SavingsIcon from "@mui/icons-material/Savings";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import GroupsIcon from "@mui/icons-material/Groups";
import NightlightRoundIcon from "@mui/icons-material/NightlightRound";
import LabelIcon from "@mui/icons-material/Label";

/**
 * Icons a badge or chip can use. The buyer app renders MaterialIcons by these
 * kebab-case names; the web preview maps them to @mui/icons-material.
 */
const ICONS: Record<string, { label: string; Icon: React.ComponentType<SvgIconProps> }> = {
  "local-fire-department": { label: "Fire", Icon: LocalFireDepartmentIcon },
  "trending-up": { label: "Trending", Icon: TrendingUpIcon },
  "local-offer": { label: "Offer tag", Icon: LocalOfferIcon },
  spa: { label: "Leaf (veg)", Icon: SpaIcon },
  "verified-user": { label: "Shield", Icon: VerifiedUserIcon },
  "thumb-up": { label: "Thumbs up", Icon: ThumbUpIcon },
  "currency-rupee": { label: "Rupee", Icon: CurrencyRupeeIcon },
  eco: { label: "Eco", Icon: EcoIcon },
  bolt: { label: "Bolt", Icon: BoltIcon },
  savings: { label: "Savings", Icon: SavingsIcon },
  "delivery-dining": { label: "Delivery", Icon: DeliveryDiningIcon },
  groups: { label: "Group", Icon: GroupsIcon },
  "nightlight-round": { label: "Moon", Icon: NightlightRoundIcon },
};

export const CARD_ICON_NAMES = Object.keys(ICONS);

export const cardIconLabel = (name: string) => ICONS[name]?.label ?? name;

export const CardIcon: React.FC<{ name: string | null | undefined } & SvgIconProps> = ({ name, ...props }) => {
  const Icon = (name && ICONS[name]?.Icon) || LabelIcon;
  return <Icon {...props} />;
};
